import React, { Suspense } from 'react';

export const MatchesSearchComponent = React.lazy(() => import('./MatchesSearch'));

export const MatchesSearch = () => (
  <Suspense fallback={null}>
    <MatchesSearchComponent />
  </Suspense>
);
